import React, {Component} from 'react'
import {Query} from 'react-apollo'

import {USER} from '../graphql/query'
import AuthLoadingScreen from './AuthLoadingScreen'

class Auth extends Component {
  render() {
    const {children} = this.props

    return (
      <Query query={USER}>
        {({loading, error, data}) => {
          if (loading) return <AuthLoadingScreen />
          return <React.Fragment>{children}</React.Fragment>
        }}
      </Query>
    )
  }
}

export default Auth



// WEBPACK FOOTER //
// ./src/auth/Auth.js